import { Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { TextField } from '@material-ui/core';

// Internal modules
import ACButton from '../../../atoms/ACButton';

import styles from '../styles/LoginForm.module.scss';

function LoginForm({ props }) {
    const {
        // authProperties,
        errors,
        handleChange,
        handleSubmit,
        isValid,
        setFieldTouched,
        touched,
        values: { username, password },
    } = props;
    // const { forgotMyPasswordLink } = authProperties;
    function onChange(name, e) {
        e.persist();
        handleChange(e);
        setFieldTouched(name, true, false);
    }

    function onPressEnter(event) {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    }

    return (
        <Form id="login-form" className={styles.root}>
            <div className={styles.textField}>
                <TextField
                    autoComplete="on"
                    classes={{
                        root: styles.textField,
                        label: styles.textFieldLabel,
                    }}
                    className={styles.textField}
                    error={touched.username && Boolean(errors.username)}
                    id="username"
                    label="Email Address"
                    helperText={touched.username ? errors.username : ''}
                    onChange={onChange.bind(null, 'username')}
                    onKeyDown={onPressEnter}
                    value={username}
                />
            </div>
            <div className={styles.textField}>
                <TextField
                    autoComplete="on"
                    id="password"
                    error={touched.password && Boolean(errors.password)}
                    label="Password"
                    type="password"
                    helperText={touched.password ? errors.password : ''}
                    onChange={onChange.bind(null, 'password')}
                    onKeyDown={onPressEnter}
                    value={password}
                />
            </div>
            <p
                className={styles.forgotMyPassword}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    color: '#D1517A',
                    fontFamily: 'gilroy-regular',
                }}
            >
                For any account related support, please Slack #tech_support
            </p>
            <ACButton
                color="white"
                border="1px solid #434f69"
                fontFamily="gilroy-regular"
                fontSize="14px"
                margin="12px 0 0 0"
                backgroundColor="#434f69"
                text={'Login'}
                onClickFunc={handleSubmit}
                disabled={!isValid}
            />
        </Form>
    );
}

LoginForm.propTypes = {
    props: PropTypes.object.isRequired,
};
LoginForm.defaultProps = {};

export default LoginForm;
